import { lazy } from 'react';
import { screenOptionsForLightMode } from '../../../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../../../functions/navigation/utils/wrapNavigatorScreen';

const CountrySelectorPageContent = lazy(
  () => import('../components/CountrySelectorPageContent'),
);

const CountrySelectorPage = wrapLazyNavigatorScreen(
  CountrySelectorPageContent,
  screenOptionsForLightMode({
    title: 'Select Country',
  }),
);

export default CountrySelectorPage;

export const CountryCodeSelectorPage = wrapLazyNavigatorScreen(
  CountrySelectorPageContent,
  screenOptionsForLightMode({
    title: 'Select Country Code',
  }),
);
